import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFullPage from 'vue-fullpage.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from "vue-gtag"
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(VueFullPage);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDGu8YCqenB6f-nGuXEjk2bQjZ_-IyFie0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VueGtag, {
  config: { id: "G-MY6XJHJQ0J" }
})
Vue.use(VueMeta)

Vue.prototype.$linksRules = {
  plansLarge: '/assets/images/plan/',
  visualisationsLarge: '/assets/images/gallery/',
  visualisationsSmall: '/assets/images/gallery-small/'
}
Vue.prototype.$building = {
  "floor": {
    "1": {
      type: "commerce"
    },
    "2": {
      type: "live",
      sheme: "10",
      apartment: {
        "1": {status: "reserved", price: "1000"},
        "2": {status: "reserved", price: "1000"},
        "3": {status: "reserved", price: "1000"},
        "4": {status: "reserved", price: "1000"},
        "5": {status: "reserved", price: "1000"},
        "6": {status: "reserved", price: "1000"},
        "7": {status: "reserved", price: "1000"},
        "8": {status: "reserved", price: "1000"},
        "9": {status: "reserved", price: "1000"},
        "10": {status: "reserved", price: "1000"}
      }
    },
    "3": {
      type: "live",
      sheme: "10",
      apartment: {
        "1": {status: "reserved", price: "1000"},
        "2": {status: "reserved", price: "1000"},
        "3": {status: "reserved", price: "1000"},
        "4": {status: "reserved", price: "1000"},
        "5": {status: "reserved", price: "1000"},
        "6": {status: "reserved", price: "1000"},
        "7": {status: "reserved", price: "1000"},
        "8": {status: "reserved", price: "1000"},
        "9": {status: "reserved", price: "1000"},
        "10": {status: "reserved", price: "1000"}
      }
    },
    "4": {
      type: "live",
      sheme: "9",
      apartment: {
        "1": {status: "reserved", price: "1000"},
        "2": {status: "reserved", price: "1000"},
        "3": {status: "reserved", price: "1000"},
        "4": {status: "reserved", price: "1000"},
        "5": {status: "reserved", price: "1000"},
        "6": {status: "reserved", price: "1000"},
        "7": {status: "reserved", price: "1000"},
        "8": {status: "reserved", price: "1000"},
        "9-large": {status: "reserved", price: "1000"}
      }
    },
    "5": {
      type: "live",
      sheme: "9",
      apartment: {
        "1": {status: "reserved", price: "1000"},
        "2": {status: "reserved", price: "1000"},
        "3": {status: "reserved", price: "1000"},
        "4": {status: "reserved", price: "1000"},
        "5": {status: "reserved", price: "1000"},
        "6": {status: "reserved", price: "1000"},
        "7": {status: "reserved", price: "1000"},
        "8": {status: "reserved", price: "1000"},
        "9-large": {status: "reserved", price: "1000"}
      }
    }
  }
}
Vue.prototype.$flats = {
  '1': {
    'planID': '1',
    'areas': [
      { name: "Загальна площа", value: "53,22", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "2" }
    ],
    'visualisations': {
      main: '/assets/images/tmp/room1.jpg',
      format: '.jpg',
      items: ['01', '02', '03', '04', '08', '05', '06', '07'],
      plans: ['/assets/images/tmp/room1.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '2': {
    'planID': '2',
    'areas': [
      { name: "Загальна площа", value: "61,83", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "2" }
    ],
    'visualisations': {
      main: '/assets/images/gallery-small/2/04.jpg',
      format: '.jpg',
      items: ['01', '02', '03', '04', '08', '05', '06', '07', '09', '10', '11'],
      plans: ['/assets/images/gallery-small/2/04.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '3': {
    'planID': '3',
    'areas': [
      { name: "Загальна площа", value: "71,0", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "2" }
    ],
    'visualisations': {
      main: '/assets/images/gallery-small/3/01.jpg',
      format: '.jpg',
      items: ['01', '02', '03', '04', '08', '05', '06', '07', '09', '10', '11'],
      plans: ['/assets/images/gallery-small/3/01.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '4': {
    'planID': '4',
    'areas': [
      { name: "Загальна площа", value: "68,57", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "2" }
    ],
    'visualisations': {
      main: '/assets/images/gallery-small/4/08.jpg',
      format: '.jpg',
      items: ['03', '04', '01', '02', '08', '05', '06', '07', '09', '10'],
      plans: ['/assets/images/gallery-small/4/08.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '5': {
    'planID': '5',
    'areas': [
      { name: "Загальна площа", value: "55,48", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      main: '/assets/images/gallery-small/5/02.jpg',
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08'],
      plans: ['/assets/images/gallery/5/02.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '6': {
    'planID': '6',
    'areas': [
      { name: "Загальна площа", value: "55,37", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08'],
      plans: ['/assets/images/gallery-small/6/06.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '7': {
    'planID': '7',
    'areas': [
      { name: "Загальна площа", value: "66,27", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "2" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10'],
      plans: ['/assets/images/gallery/7/01.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '8': {
    'planID': '8',
    'areas': [
      { name: "Загальна площа", value: "48,0", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
      plans: ['/assets/images/gallery/8/05.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '8-b': {
    'planID': '8',
    'areas': [
      { name: "Загальна площа", value: "48,0", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['07', '08', '09', '01', '02', '03', '04', '05', '06', '10', '11'],
      plans: ['/assets/images/gallery/8/05.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '9': {
    'planID': '9',
    'areas': [
      { name: "Загальна площа", value: "44,73", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10'],
      plans: ['/assets/images/gallery/9/05.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '10': {
    'planID': '10',
    'areas': [
      { name: "Загальна площа", value: "44,8", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "1" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
      plans: ['/assets/images/gallery/10/05.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  '9-large': {
    'planID': '9',
    'title': 'Житло 9-10',
    'areas': [
      { name: "Загальна площа", value: "92,42", unit: "m<sup>2</sup>" },
      { name: "Кількість кімнат", value: "3" }
    ],
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13'],
      plans: ['/assets/images/gallery/9-large/05.jpg']
    },
    'plans': {
      format: '.png',
      items: ['01', '02', '03', '04', 'top']
    }
  },
  'office-1': {
    'title': 'Приклад офісного приміщення',
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13']
    }
  },
  'corridor': {
    'title': 'Коридор житлових приміщень',
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
    },
  },
  'lobby': {
    'title': 'Лоббі',
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07', '08']
    },
  },
  'terrace': {
    'title': 'Тераса',
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05', '06', '07']
    },
  },
  'corridor-office': {
    'title': 'Коридор офісних приміщень',
    'visualisations': {
      format: '.jpg',
      items: ['01', '02', '03', '04', '05']
    }
  }
};
Vue.prototype.$news = [
  {
    title: 'Насолоджуйтесь краєвидами на панорамній лоджії!',
    slug: 'nasolodzhujtes-krayevidami-na-panoramnij-lodzhiyi',
    date: 'місяць тому',
    thumbnail: '/assets/images/news-small/panoram.jpg',
    shorttext: 'Панорамне скління – це візитна картка житлового комплексу Gentleman Park.  На фасадах житлових будинків передбачені енергоефективні 6-камерні склопакети з алюмінієвим профілем німецького виробника Kömmerling, якому клієнти довіряють вже понад п`ятдесят років.',
    text: '<p>Панорамне скління – це візитна картка житлового комплексу Gentleman Park.</p><p>На фасадах житлових будинків передбачені енергоефективні 6-камерні склопакети з алюмінієвим профілем німецького виробника Kömmerling, якому клієнти довіряють вже понад п`ятдесят років.</p><p>Оскільки більшість вікон уже на місці, розкажемо вам чому саме ми зупинили свій вибір на вікнах з профілю Kömmerling.</p><p>Ми встановлюємо Kömmerling 70ST plus — віконну 6-камерну систему шириною 70 мм. Вона має підвищену тепло- і звукоізоляцію, сучасний дизайн зі скошеними видимими краями. Саме вікна з профілю Kömmerling 70ST plus поєднують функціональність, зручність і абсолютну безпеку. 6-камерна система Kömmerling має можливість встановлення більш широкого склопакета, що дозволить Вам не тільки зберегти тепло і затишок будинку, а й заощадити гроші на опаленні, відмовившись від додаткових обігрівачів.</p><p>Крім відмінних характеристик з теплоізоляції та енергоощадження, завдяки високій щільності закривання стулки, вікна з профілю Kömmerling 70ST plus мають підвищені звукоізоляційні властивості.</p><p>Рекомендуємо вам для комфорту на лоджії облаштувати зону відпочинку, щоб насолоджуватись урбаністичним пейзажем міста за келехом вина.</p>'
  },
  {
    title: 'Безпечний джентльмен',
    slug: 'bezpechnij-gentleman',
    date: 'два місяці тому',
    thumbnail: '/assets/images/news-small/security.jpg',
    shorttext: 'Пригадуєте той переломний момент стрімкого розвитку цифрових технологій та який вплив вони мають на наше життя у сучасності? Зараз ми знаходимось на кордоні усвідомлення того, що "щастя любить тишу", а питання безпеки є надважливим.',
    text: '<p>Пригадуєте той переломний момент стрімкого розвитку цифрових технологій та який вплив вони мають на наше життя у сучасності? Зараз ми знаходимось на кордоні усвідомлення того, що "щастя любить тишу", а питання безпеки є надважливим.</p><p>Наша команда відповідально віднеслась до цього питання, тому, придбавши житло саме у нас, ви отримаєте:</p><p>Цілодобовий відеонагляд довкола будинку в кількості 17 відеокамер Hikvision. Крім того, камери будуть встановлені на кожному поверсі та в ліфті.</p><p>Завдяки вбудованому ІЧ-підсвічуванню, камери можуть вести нічне знімання на відстані до 30 метрів. Камери автоматично будуть перемикатися між денним та нічним зніманням.</p><p>Камери Hikvision DS-2CD2041G1-IDW1 виготовлені на базі сенсора Progressive CMOS з професійним процесором, який дозволяє отримувати чіткі і яскраві зображення.</p><p>Автоматичний шлагбаум NICE від італійської компанії. Модель розрахована 500 000 циклів відкривання / закривання. Якщо врахувати, що в середньому шлагбаум NICE буде використовуватися близько 100 разів на день, то термін служби можна прирівняти до чотирнадцяти років експлуатації.</p><p>У кожному житлі буде встановлений відеодомофон, тому ніхто зі сторонніх не потрапить в будинок.</p><p>Ви зможете не тільки безпечно залишати свій велосипед, або дитячий візок у передбаченому для цього місці в будинку, а й бути впевненим в безпеці вашого майна.</p><p>Ми облаштуємо закритий дитячий майданчик з внутрішньої сторони прибудинкової території, щоб ваші дітки могли безпечно проводити час на відкритому повітрі.</p>'
  },
  {
    title: 'Співпраця з Vaillant',
    slug: 'spivpracya-z-vaillant',
    date: 'чотири місяці тому',
    thumbnail: '/assets/images/news-small/vaillant.jpg',
    shorttext: 'ЖБК “Gentleman Park” співпрацює з надійним німецьким виробником котлів Vaillant! Vaillant є лідером ринку в області технологій опалення та вентиляції, починаючи з 1874 року.',
    text: '<p>ЖБК “Gentleman Park” співпрацює з надійним німецьким виробником котлів Vaillant! </p><p>Vaillant є лідером ринку в області технологій опалення та вентиляції, починаючи з 1874 року.</p><p>Ми пропонуємо найкращу ціну на ринку на газові сертифіковані котли Vaillant та персональну знижку на монтаж.</p><p>Котли Vaillant - це технологічна революція на ринку: тепловий насос економить не тільки енергію, але й знижуює викиди CO2. Це економія грошей та захист навколишнього середовища.</p><p>Зрештою, ви отримаєте систему опалення з низькими витратами та високою надійністю в роботі. Газові котли Vaillant будуть служити вам протягом десятиліть.</p>'
  },
  {
    title: 'Дотримуємось плану: екватор подолано',
    slug: 'dotrimuyemos-planu-ekvator-podolano',
    date: 'шість місяців тому',
    thumbnail: '/assets/images/news-small/ekvator.jpg',
    shorttext: 'Дотримуємось плану: екватор подолано. Ми можемо сміло заявити, що з початком весни будівництво перетнуло екватор.Поки ви "карантинили" та святкували,  ми продовжували невпинно працювати для вчасної здачі проєкту.',
    text: '<p>Ми можемо сміло заявити, що з початком весни будівництво перетнуло екватор.</p><p>Поки ви "карантинили" та святкували,  ми продовжували невпинно працювати для вчасної здачі проєкту.</p><p>Ми гордимось, що зібрали команду професіоналів, які чітко виконують свою роботу.</p><p>А чи знаєте ви про головні переваги придбання нерухомості на ранніх стадіях будівництва?⠀</p><p>Ціна та інвестиційна привабливість: на кожному етапі будівництва ціна за квадратний метр зростає, а тому інвестиції в будинок, що тільки будується — найвигідніші;</p>⠀<p>Свобода вибору: на початкових стадіях будівництва досить легко обрати бажаний поверх, планування і навіть краєвид з вікон. Що ближче зведення будинку до завершення, тим менший вибір;⠀</p><p>Висока якість житла: новий будинок зводиться відповідно до всіх вимог, норм і правил сучасного будівництва.⠀</p><p>Саме тому ми радимо купувати житло на ранніх стадіях будівництва.</p>'
  },
  {
    title: 'А як щодо дизайну вашого житла?',
    slug: 'a-yak-shodo-dizajnu-vashoyi-kvartiri',
    date: 'сім місяців тому',
    thumbnail: '/assets/images/news-small/design.jpg',
    shorttext: 'Ви уже знаєте, як саме повинне виглядати ваше житло? В сучасному світі дім - це місце для відновлення енергії, для пошуку нових ідей, для релаксації, для затишку та спокою.',
    text: '<p>А як щодо дизайну вашого житла? Ви уже знаєте, як саме повинне виглядати ваше житло? В сучасному світі дім - це місце для відновлення енергії, для пошуку нових ідей, для релаксації, для затишку та спокою.</p><p>Купуючи первинне житло, ви маєте можливість спланувати кожен квадратний метр з користю та згідно своїх вподобань. Відтепер ви самі вирішуєте, де у вас буде стіна, якого розміру у вас буде кухня чи спальня, та що краще - шафа, чи власна своя гардеробна кімната.</p><p>Ми розуміємо, що ремонт житла – це складний технічно та психологічно процес, результат якого буде впливати на ваше життя. Наша команда заздалегідь подбала про те, щоб навіть після придбання житла в нашому комплексі “Gentleman Park”, вам було комфортно та легко.</p><p>До кожного житла ми пропонуємо наш варіант планування та дизайн інтер’єру. Завдяки комп’ютерним методам моделювання інтер’єру ми візуалізуємо вашу домівку, або ж разом з вами пофантазуємо над кольором дивану у вітальні.</p><p>З нашими роботами ви можете ознайомитись уже зараз в галереї.</p>'
  }
]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
